import { FlexColumn, FullContainer } from '@gorila-shared-ui/components';
import { SnackbarProvider } from 'baseui/snackbar';
import { ToasterContainer } from 'baseui/toast';
import React from 'react';
import { MapProvider } from 'react-map-gl/mapbox';
import { useStyles } from '../../../hooks/useStyles';
import PageLayout from '../../layout/PageLayout';
import { AppProvider } from '../../providers/AppProvider';
import { HeadTitle } from '../HeadTitle';

type Props = Readonly<{
  navbar?: React.ReactNode;
  providers?: React.ReactNode;
}>;

function PublicDashboardWrapper({ navbar, providers }: Props) {
  const { css, theme } = useStyles();

  return (
    <MapProvider>
      <SnackbarProvider placement="top">
        <AppProvider />
        <HeadTitle />
        {providers}
        <FullContainer flexible>
          <FlexColumn
            classNames={css({
              flex: 1,
              overflowX: 'hidden',
            })}
            gap={0}
          >
            {navbar}
            <PageLayout />
          </FlexColumn>
        </FullContainer>
        <ToasterContainer
          autoHideDuration={2500}
          placement="topRight"
          resetAutoHideTimerOnUpdate
          usePortal={false}
          closeable={true}
          overrides={{
            Root: {
              style: {
                marginTop: '64px',
                marginRight: theme.sizing.scale400,
              },
            },
          }}
        />
      </SnackbarProvider>
    </MapProvider>
  );
}

export default PublicDashboardWrapper;
